/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function NumberValidationFromJSON(json) {
    return NumberValidationFromJSONTyped(json, false);
}
export function NumberValidationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        max: !exists(json, 'max') ? undefined : json['max'],
        min: !exists(json, 'min') ? undefined : json['min'],
    };
}
export function NumberValidationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        max: value.max,
        min: value.min,
    };
}
